<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<section id="wrapper" class="error-page">
    <div class="error-box">
        <div class="error-body text-center">
            <h1>404</h1>
            <h3 class="text-uppercase">Pagina no encontrada</h3>
            <a href="index.html" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Regresar al inicio</a> </div>
        <footer class="footer text-center">© {{ year }} SIGE</footer>
    </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->